<template>
  <LecturerHomepageWtxh v-if="siteId == 116" />
  <LecturerHomepageDefault v-else />
</template>

<script>
import LecturerHomepageDefault from "./lecturerHomepageDefault.vue";
import LecturerHomepageWtxh from "./lecturerHomepageWtxh.vue";

export default {
  name: "LecturerHomepageContainer",
  components: {
    LecturerHomepageDefault,
    LecturerHomepageWtxh,
  },
  data() {
    return {
      siteId: null,
    };
  },
  created() {
    let info = localStorage.getItem("siteInfo");
    if (info) {
      this.siteId = JSON.parse(info).id;
    }
  },
};
</script>
